import { render, staticRenderFns } from "./PlanejamentoEstimativa.vue?vue&type=template&id=947855e0&"
import script from "./PlanejamentoEstimativa.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoEstimativa.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoEstimativa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports